import { useEffect } from "react";

/**
 * Lightweight SEO hook for a SPA — sets document.title, meta description,
 * canonical URL, and Open Graph tags per route. Runs on mount and when args change.
 */
export function useSeo({ title, description, canonical, path } = {}) {
  useEffect(() => {
    const suffix = " — R-1.immo";
    const fullTitle = title
      ? (title.endsWith("R-1.immo") ? title : `${title}${suffix}`)
      : "R-1.immo — Louez vos m² inutilisés en sous-sol";
    document.title = fullTitle;

    setMeta("description", description || "R-1.immo — La marketplace des sous-sols, caves, parkings, réserves et locaux atypiques. Valorisez vos m² invisibles ou trouvez un lieu compatible avec votre activité.");

    const origin = typeof window !== "undefined" ? window.location.origin : "https://r-1.immo";
    const url = canonical || (path ? `${origin}${path}` : (typeof window !== "undefined" ? window.location.href.split("?")[0] : origin));
    setLink("canonical", url);

    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description || "R-1.immo — Louez vos m² inutilisés en sous-sol.", "property");
    setMeta("og:url", url, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:image", `${origin}/logo.png`, "property");
    setMeta("og:locale", "fr_FR", "property");

    setMeta("twitter:card", "summary");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description || "R-1.immo — Louez vos m² inutilisés en sous-sol.");
    setMeta("twitter:image", `${origin}/logo.png`);
  }, [title, description, canonical, path]);
}

function setMeta(name, content, attr = "name") {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
